import type { Tarjima } from "./i18n";

/**
 * Bo'lim profilining yorliqlari — `employees/utils/tabs.ts` bilan BIR XIL
 * naqsh, tartib UI'dagi tartib bilan bir xil.
 *
 * ⚠️ "Sozlamalar" `departments:update` YOKI `departments:archive` talab
 * qiladi (`DEPARTMENT_TAB_PERMISSION`) — ikkalasi ham yo'q bo'lsa tabda
 * bajarish mumkin bo'lgan hech qanday amal yo'q (review Important 2).
 * «Umumiy» ruxsatsiz, ya'ni ruxsat etilganlar ro'yxati HECH QACHON bo'sh
 * bo'lmaydi — `resolveTab` ning zaxira qiymati shu kafolatga tayanadi.
 */
export const DEPARTMENT_TABS = [
	"umumiy",
	"bolinmalar",
	"xodimlar",
	"hududlar",
	"topshiriqlar",
	"sozlamalar",
] as const;

export type DepartmentTab = (typeof DEPARTMENT_TABS)[number];

/** Matn `departments.json`ning `tabs.*` kalitlaridan. */
export function departmentTabLabel(t: Tarjima, tab: DepartmentTab): string {
	return t(`tabs.${tab}`);
}

/**
 * Yorliqning ruxsat darvozasi — `[resource, action]` juftliklari ro'yxati,
 * BIRORTASI yetarli («any of»). Ro'yxatda BO'LMAGAN yorliq qo'shimcha ruxsat
 * talab qilmaydi.
 */
export const DEPARTMENT_TAB_PERMISSION: Partial<Record<DepartmentTab, [string, string][]>> = {
	// `GET /employees` — usiz yorliq ko'rinib, ichida 403 bilan bo'sh jadval chiqardi.
	xodimlar: [["employees", "read"]],
	hududlar: [["zones", "read"]],
	topshiriqlar: [["tasks", "read"]],
	// ⚠️ Ikkalasi ham yo'q bo'lsa rahbar tabda faqat bo'lim nomini ko'rardi,
	// hech qanday amal bajara olmasdi (review Important 2).
	sozlamalar: [
		["departments", "update"],
		["departments", "archive"],
	],
};

/**
 * Yorliq ruxsat etilganmi — `DEPARTMENT_TAB_PERMISSION` dagi juftliklardan
 * BIRORTASI yetarli. Ro'yxatda yo'q yorliq (masalan «Umumiy», «Bo'linmalar»)
 * har doim `true` — shu kafolat tufayli ruxsat etilganlar ro'yxati hech
 * qachon bo'sh bo'lmaydi (`resolveTab` ning zaxira qiymati shunga tayanadi).
 */
export function isTabAllowed(
	tab: DepartmentTab,
	can: (resource: string, action: string) => boolean
): boolean {
	const ruxsatlar = DEPARTMENT_TAB_PERMISSION[tab];
	if (!ruxsatlar) {
		return true;
	}
	return ruxsatlar.some(([resource, action]) => can(resource, action));
}

/**
 * URL'dagi `?tab=` qiymatini RUXSAT ETILGAN yorliqqa aylantiradi.
 *
 * ⚠️ Noma'lum qiymatda 404 EMAS, birinchi ruxsat etilgan yorliqqa tushadi —
 * eskirgan havola sahifani buzmasligi kerak.
 *
 * ⚠️ `allowed` ni tekshirish MAJBURIY, `DEPARTMENT_TABS` yetarli EMAS:
 * `?tab=hududlar` bilan kelgan `zones:read` siz foydalanuvchi mavjud
 * bo'lmagan yorliqni faol deb ko'rardi va `Tabs` BO'SH chiqardi.
 *
 * ⚠️ Kirish `string` ekani kafolatlanmaydi — `validateSearch` yo'q, ya'ni
 * `?tab=a&tab=b` massiv beradi.
 */
export function resolveTab(
	raw: string | undefined,
	allowed: readonly DepartmentTab[]
): DepartmentTab {
	const zaxira = allowed[0] ?? DEPARTMENT_TABS[0];

	if (typeof raw !== "string") {
		return zaxira;
	}

	return (allowed as readonly string[]).includes(raw) ? (raw as DepartmentTab) : zaxira;
}
